import axios from "axios";

//Caso ocorra algum erro no servidor (de teste ou de produção), o erro pode ser a falta da
//url completa no lugar do /api
const apiUrl = process.env.NODE_ENV === "production" ? "https://api.zecon.compjunior.com.br" : "http://localhost:3000";

const api = axios.create({
    baseURL: apiUrl,
  });

export { api }; 
